import { IFileMetaData } from '@store/reducers/document-upload/document-upload.reducer';
import { PDFDocument } from 'pdf-lib';

export interface MergeFilesToPdfOptions {
  files: IFileMetaData[];
  fetchFn: (url: string) => Promise<Response>;
  // For existing logging for image conversion
  onConversion?: (eventId: string, message: string) => void;
}

export async function mergeFilesToPdf(options: MergeFilesToPdfOptions): Promise<PDFDocument> {
  const pdfDoc = await PDFDocument.create();

  for (const file of options.files) {
    const response = await options.fetchFn(file.objectURL);
    const contentType = response.headers.get('Content-Type');
    const byteArray = await response.arrayBuffer();

    if (contentType === 'application/pdf') {
      const PDFObject = await PDFDocument.load(byteArray);
      const totalPagesCount = PDFObject.getPageCount();
      const pageArray = [];

      for (let i = 0; i < totalPagesCount; i++) {
        pageArray.push(i);
      }

      const copiedPages = await pdfDoc.copyPages(PDFObject, pageArray);

      if (copiedPages.length > 0) {
        copiedPages.forEach((page) => {
          pdfDoc.addPage(page);
        });
      }
    } else if (contentType === 'image/jpeg' || contentType === 'image/jpg') {
      const jpegImage = await pdfDoc.embedJpg(byteArray);
      const page = pdfDoc.addPage();
      const resizedDim = jpegImage.scaleToFit(page.getWidth(), page.getHeight());
      page.drawImage(jpegImage, {
        x: 0,
        y: 0,
        width: resizedDim.width,
        height: resizedDim.height,
      });

      options.onConversion?.('convertingJPG/JPEG-status', 'JPG/JPEG conversion');
    } else if (contentType === 'image/png') {
      const pngImage = await pdfDoc.embedPng(byteArray);
      const page = pdfDoc.addPage();
      const resizedDim = pngImage.scaleToFit(page.getWidth(), page.getHeight());
      page.drawImage(pngImage, {
        x: 0,
        y: 0,
        width: resizedDim.width,
        height: resizedDim.height,
      });

      options.onConversion?.('convertingPNG-status', 'PNG conversion');
    }
  }

  return pdfDoc;
}
